export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YK5sik8s6yLUrwB0lw.0ad7b2e5.woff2";